import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError, receiveSuccess } from '../../../store/actions/notificationAction';
import { setOrderLocked } from '../../../store/actions/orderLockedAction';

import ghaRemote from '../../../api/ghaRemote';
import pickupOrderRemote from '../../../api/pickupOrderRemote';
import offlineRfsRemote from '../../../api/offlineRfsRemote';

import WhsOrderDetails from './WhsOrderDetails';

import GhaDock from '../../../models/GhaDock';
import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import OrderWhsDetails from '../../../models/OrderWhsDetails';
import { OrderLockStatusType } from '../../../models/OrderLockStatusType.enum';
import AttachmentsContainer from '../../attachments/AttachmentsContainer';
import attachmentsRequestHandler from '../../../api/attachmentsRemote';

interface WhsOrderDetailsContainerProps {
  type: string;
  history: { push: Function; };
  match: { isExact: boolean; params: { number: string, wh: string }; path: string; url: string; };
  receiveError: Function;
  receiveSuccess: Function;
  selectedAwb: string;
  location: any;
  setOrderLocked: Function;
};
  
interface WhsOrderDetailsContainerState {
  order: OrderWhsDetails;
  awbCode: string;
  awbNumber: string;
  version: number;
  driverIdManual: string;
  driverIdTypeManual: string;
  selectedAwb: string;
  selectedDock: number;
  ghaDocks: Array<GhaDock>;
  isAttachmentsDialogOpen: boolean;
  isWarehouse: boolean;
};

class WhsOrderDetailsContainer extends Component<WhsOrderDetailsContainerProps, WhsOrderDetailsContainerState> {

  state = {
    order: {
      number: '',
      order_type: '',
      delivery_company_name: '',
      delivery_company_phone: '',
      driver_name: '',
      driver_contact: '',
      driver_id_type: '',
      driver_id: '',
      gha_wh_user_name: '',
      lock_status: '',
      awb_location_list: [],
      status: '',
      id_gha: -1,
      id_dock: -1,
      list: [],
      seal_lock_verified: null,
      allowed_ops: {
        update_date: true,
        update_awb_address: true,
        update_dispatch_driver_details: true,
        driver_checked_in: true,
        update_wh_locations: true,
        set_dock: true,
        update_exception_and_notes: true,
        update_customs_clearance: true
      },
      id: -1,
      dst_gha: -1
    },
    driverIdManual: '',
    driverIdTypeManual: 'CDL',
    selectedAwb: '',
    selectedDock: -1,
    ghaDocks: [],
    awbCode: '',
    awbNumber: '',
    version: 0,
    isAttachmentsDialogOpen: false,
    isWarehouse: false
  }
  
  componentDidMount() {

    const number: string = this.props.match.params.number;

    if(this.props.type === 'po' || this.props.type === 'do' || this.props.type === 'go') {
      if (number) {
        this.props.setOrderLocked(number);
        this.getAwbsPerPickupOrder(number);
      }
      if(this.props.location.state) {
        const selectedAwb = this.props.location.state.selectedAwb;
        this.setState({ selectedAwb, version: this.props.location.state.version });
      }
    }
    if(this.props.type === 'rfs') {
      if (number) {
        let orderNumber = number
        if(number.indexOf('-')) {
          const numberArr = number.split("-");
          orderNumber = numberArr[0];
          if(numberArr[1]==='wh') {
            this.setState({ isWarehouse: true });
          }
        }
        this.props.setOrderLocked(orderNumber);
        this.getAwbsPerOfflineOrder(orderNumber);
      }
    }
  }

  componentWillUnmount() {

    this.unlockOrder();
  }

  getAwbsPerPickupOrder = (number: string): void => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const start = params.get('start');
    pickupOrderRemote.getPickupOrderWhs(number, '', Boolean(start)).then((resp: ApiResponse<OrderWhsDetails>) => {

      const order: OrderWhsDetails | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (order) {
        
        this.setState({ order });

        this.getGhaDocks(order.id_gha);

        if (order.lock_status === OrderLockStatusType.UNLOCKED) {
          this.doLockPickupOrder();
        }
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  getAwbsPerOfflineOrder = (number: string): void => {

    offlineRfsRemote.getOfflineOrderWhs(number).then((resp: ApiResponse<OrderWhsDetails>) => {

      const order: OrderWhsDetails | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (order) {
        this.setState({ order });
        if(this.props.type === 'rfs') {
          this.getGhaDocks(order.dst_gha);
        } else {
          this.getGhaDocks(order.id_gha);
        }


        if (order.lock_status === OrderLockStatusType.UNLOCKED || this.state.isWarehouse) {
          this.doLockPickupOrder();
        }
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  getGhaDocks = (ghaID: number): void => {

    ghaRemote.getGhaDocks(ghaID).then((resp: ApiResponse<Array<GhaDock>>) => {

      const docks: Array<GhaDock> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (docks && docks.length > 0) {
        this.setState({ ghaDocks: docks });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  updateDriverId = (): void => {

    const driverId: string = this.state.driverIdManual;
    const driverIdType: string = this.state.driverIdTypeManual;

    if (driverId && !driverIdType ) {
      // TODO: error
      console.log('not driverIdType')
    }

    pickupOrderRemote.updateGhaWhPoAwbDriverId(this.state.order.number, driverId, driverIdType).then((resp: ApiResponse<boolean>) => {

      const updated: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (updated) {
        const order: OrderWhsDetails = { ...this.state.order };

        order.driver_id = driverId;
        order.driver_id_type = driverIdType;
        this.setState({ order });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  doLockPickupOrder = (): void => {

    const locked: boolean = this.state.order.lock_status === OrderLockStatusType.UNLOCKED;

    if((this.props.type === 'po' || this.props.type === 'do' || this.props.type === 'go') && this.state.order.number) {

      pickupOrderRemote.doGhaWhPoLock(this.state.order.number, locked).then((resp: ApiResponse<{ lock_status: string; gha_wh_user_name: string; }>) => {

        const updateValues: { lock_status: string; gha_wh_user_name: string; } | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (updateValues) {
          const order: OrderWhsDetails = { ...this.state.order };

          order.lock_status = updateValues.lock_status;
          order.gha_wh_user_name = updateValues.gha_wh_user_name;

          this.setState({ order });
        }
    
        if (error) {
          this.props.receiveError(error);
        };
      });
    }

    if(this.props.type === 'rfs') {

      offlineRfsRemote.doGhaWhPoLock(this.state.order.id, locked, this.state.isWarehouse).then((resp: ApiResponse<{ lock_status: string; gha_wh_user_name: string; }>) => {

        const updateValues: { lock_status: string; gha_wh_user_name: string; } | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (updateValues) {
          if(this.state.isWarehouse) {
            this.props.history.push(`/whs/${this.props.type}/${this.state.order.id}`);
          }
          const order: OrderWhsDetails = { ...this.state.order };

          order.lock_status = updateValues.lock_status;
          order.gha_wh_user_name = updateValues.gha_wh_user_name;

          this.setState({ order });
        }
    
        if (error) {
          this.props.receiveError(error);
        };
      });
    }
  }

  handleChangeDriverId = (event: React.ChangeEvent<HTMLInputElement>): void => {

    const value: string = event.target.value.trim();
    const id: string = event.target.id;
  
    switch (id) {
      case 'driverIdType' : this.setState({ driverIdTypeManual: value.toUpperCase() }); break;
      case 'driverId' : this.setState({ driverIdManual: value }); break;
      default : break;
    }
  }
  
  handleChangeAwb = (awbNumber: string, version: number): void => {

    this.setState({ selectedAwb: awbNumber, version });
  }

  handleDockChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {

    const dockID: number | null = event.target.value === '-1' ? null : +event.target.value;

    if(this.props.type === 'po' || this.props.type === 'do' || this.props.type === 'go') {

      pickupOrderRemote.setGhaWhPoAwbDock(this.state.order.number, dockID).then((resp: ApiResponse<boolean>) => {

        const selected: boolean | undefined = resp.success;
        const error: ResponseError | undefined = resp.error;

        if (selected) {

          const dock: number = dockID === null ? -1 : dockID;
          const order: OrderWhsDetails = { ...this.state.order };
          order.id_dock = dock;

          this.setState({ selectedDock: dock, order });
        }
    
        if (error) {
          this.props.receiveError(error);
        };
      });
    }

    if(this.props.type === 'rfs') {

      offlineRfsRemote.setGhaWhPoAwbDock(this.state.order.id, dockID).then((resp: ApiResponse<boolean>) => {

        const selected: boolean | undefined = resp.success;
        const error: ResponseError | undefined = resp.error;

        if (selected) {

          const dock: number = dockID === null ? -1 : dockID;
          const order: OrderWhsDetails = { ...this.state.order };
          order.id_dock = dock;

          this.setState({ selectedDock: dock, order });
        }
    
        if (error) {
          this.props.receiveError(error);
        };
      });
    }
  }

  handleSetTruckOnDock = (): void => {

    if(this.props.type === 'po' || this.props.type === 'do' || this.props.type === 'go') {

      pickupOrderRemote.setGhaWhPoAwbTruckOnDock(this.props.match.params.number).then((resp: ApiResponse<boolean>) => {

        const set: boolean | undefined = resp.success;
        const error: ResponseError | undefined = resp.error;

        if (set) {
          this.props.receiveSuccess('Truck on Dock information is confirmed.');
        }
    
        if (error) {
          if(error.errorCode == '#actionNotAllowedDueToOrderStatus') {
            this.props.receiveError({longDescription: 'Truck already on dock'});
          } else {
            this.props.receiveError(error);
          }
        }
      });
    }

    if(this.props.type === 'rfs') {

      offlineRfsRemote.setGhaWhPoAwbTruckOnDock(this.state.order.id).then((resp: ApiResponse<boolean>) => {

        const set: boolean | undefined = resp.success;
        const error: ResponseError | undefined = resp.error;

        if (set) {
          this.props.receiveSuccess('Truck on Dock information is confirmed.');
        }
    
        if (error) {
          if(error.errorCode == '#actionNotAllowedDueToOrderStatus') {
            this.props.receiveError({longDescription: 'Truck already on dock'});
          } else {
            this.props.receiveError(error);
          }
        }
      });
    }
  }

  sealLockVerify = (value: boolean | null): void => {

    if(this.props.type === 'po' || this.props.type === 'do' || this.props.type === 'go') {

      pickupOrderRemote.setSealLockVerify(this.state.order.number, value).then((resp: ApiResponse<boolean>) => {

        const success: boolean | undefined = resp.success;
        const error: ResponseError | undefined = resp.error;

        if (success) {
          const order: OrderWhsDetails = { ...this.state.order };
          order.seal_lock_verified = value;
          this.setState({ order });
        }
    
        if (error) {
          this.props.receiveError(error);
        };
      });
    }

    if(this.props.type === 'rfs') {

      offlineRfsRemote.setSealLockVerify(this.state.order.id, value).then((resp: ApiResponse<boolean>) => {

        const success: boolean | undefined = resp.success;
        const error: ResponseError | undefined = resp.error;

        if (success) {
          const order: OrderWhsDetails = { ...this.state.order };
          order.seal_lock_verified = value;
          this.setState({ order });
        }
    
        if (error) {
          this.props.receiveError(error);
        };
      });
    }
  }

  gotoAwbPage = (type: 'report' | 'weight'): void => {
    const awbData: Array<string> = this.state.selectedAwb.split('-');
    const awbCode: string = awbData[0];
    const awbNumber: string = awbData[1];
    const number = (this.props.type === 'rfs')? this.state.order.id : this.state.order.number;

    this.props.history.push({
      pathname: `/whs/${this.props.type}/awb/${type}/${number}/${awbCode}/${awbNumber}/${this.state.version}`,
      state: {
        onlyRead: !this.state.order.allowed_ops.update_exception_and_notes
      }
    })
  }

  gotoOrderNote = (): void => {

    const number = (this.props.type === 'rfs')? this.state.order.id : this.state.order.number

    this.props.history.push({
      pathname: `/whs/${this.props.type}/note/${number}`,
      state: {
        onlyRead: !this.state.order.allowed_ops.update_exception_and_notes
      }
    });
  }

  gotoDriverSignature = (): void => {
    if (this.props.type === 'po') {
      this.props.history.push(`/whs/po/drv-signature/${this.state.order.number}`);
      } else if(this.props.type === 'do') {
        this.props.history.push(`/whs/do/drv-signature/${this.state.order.number}`);
      } else if(this.props.type === 'go') {
        this.props.history.push(`/whs/go/drv-signature/${this.state.order.number}`);
    } else if(this.props.type === 'rfs') {
      this.props.history.push(`/whs/rfs/drv-signature/${this.state.order.id}`);
    } else {
      throw new Error('Incorrect type of order. It can be only po or do.');
    }
  }

  responseHandler = (resp: ApiResponse<boolean>, doUpdateExportAwbs?: boolean): void => {

    const error: ResponseError | undefined = resp.error;

    if (error) {
      this.props.receiveError(error);
    };
  }

  gotoPosPage = async (): Promise<void> => {
    if(this.state.order.number)
      await pickupOrderRemote.doGhaWhPoLock(this.state.order.number, false);
    this.props.setOrderLocked('');
    this.props.history.push('/dock-activity');
  }

  uploadFile = (event: any, code: string, number: string, version: number): void => {
    const input =  document.getElementById('fileUpload');
    if(input) {
      input.click();
      input.onchange = (event: any) => {      
        if(event.target.files[0]) {
          const formData: FormData = new FormData();
          formData.append('attachment', event.target.files[0]);
          attachmentsRequestHandler.uploadFile(code, number, version, 'awb_other', formData).then((resp) => this.responseHandler(resp, true));
        }
      }
    } 
  }

  unlockOrder = async (): Promise<void> => {

    if((this.props.type === 'po' || this.props.type === 'do' || this.props.type === 'go') && this.state.order.number) {
      await pickupOrderRemote.doGhaWhPoLock(this.state.order.number, false);
    }
    if(this.props.type === 'rfs' && this.state.order.number) {
      await offlineRfsRemote.doGhaWhPoLock(this.state.order.id, false);
    }
    this.props.setOrderLocked('');
  }

  goToPoDPage = (code: string, number: string, version: number): void => {
    this.props.history.push({
      pathname: `/whs/pod/${code}/${number}/${version}`,
      state: {
        type: this.state.order.order_type,
        orderNumber: this.state.order.number
      }
    });
  }

  openDialog = (type: string, awbCode: string, awbNumber: string, version: number): void => {
    this.setState({ awbCode, awbNumber, version }, () => {
      switch (type) {
        case 'attachments' : this.setState({ isAttachmentsDialogOpen: true });
          break;
      }
    });
      
  }

  closeDialog = (type: string): void => {
    switch (type) {
      case 'attachments' : this.setState({ isAttachmentsDialogOpen: false });
        break;
    }
  }

  render() {

    return (
      <React.Fragment>
        <WhsOrderDetails 
          type={this.props.type}
          order={ this.state.order }
          selectedDock={ this.state.selectedDock }
          docks={ this.state.ghaDocks }
          handleChangeDriverId={ this.handleChangeDriverId }
          driverIdManual={ this.state.driverIdManual }
          updateDriverId={ this.updateDriverId }
          doLockPickupOrder={ this.doLockPickupOrder }
          selectedAwb={ this.state.selectedAwb }
          handleChangeAwb={ this.handleChangeAwb }
          handleDockChange={ this.handleDockChange }
          handleSetTruckOnDock={ this.handleSetTruckOnDock }
          gotoAwbPage={ this.gotoAwbPage }
          gotoOrderNote={ this.gotoOrderNote }
          gotoDriverSignature={ this.gotoDriverSignature }
          gotoPosPage={ this.gotoPosPage }
          sealLockVerify = { this.sealLockVerify }
          handleOpenPoD={ this.goToPoDPage }
          openDialog={ this.openDialog }
          driverIdTypeManual={ this.state.driverIdTypeManual }
          history={ this.props.history }
          uploadFile={ this.uploadFile }
        />
        { this.state.isAttachmentsDialogOpen &&
          <AttachmentsContainer
            code={ this.state.awbCode }
            number={ this.state.awbNumber }
            version={ this.state.version }
            process='export'
            closeAttachments={ ()=> this.closeDialog('attachments') }
            refreshAwbs={ false }
            onlyRead={ true }
          />
        }
      </React.Fragment>
    )
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess: (message: string) => dispatch(receiveSuccess(message)),
    setOrderLocked: (orderNumber: string) => dispatch(setOrderLocked(orderNumber))
  };
};
  
export default connect(null, mapDispatchToProps)(WhsOrderDetailsContainer);
